import { injectIntl } from 'react-intl';
import VoucherEditReasonSelect from './VoucherEditReasonSelect';

export default injectIntl(VoucherEditReasonSelect);
